module.exports = __webpack_public_path__ + "img/bg1.81358436.png";